package com.playoffpulse.shared.logic

object PlayoffTextFormatter {
    fun formatPts(points: Int): String {
        val pointLabel = if (points == 1) "pt" else "pts"
        return "${points}${pointLabel}"
    }

    fun formatRequirement(points: Int): String {
        val halfGamesText = if (points % 2 == 0) {
            (points / 2).toString()
        } else {
            "${points / 2}.5"
        }
        val gameLabel = if (points == 2) "game" else "games"
        return "${formatPts(points)} (${halfGamesText} ${gameLabel})"
    }

    fun formatPtsWins(points: Int): String {
        val wins = (points + 1) / 2
        val winLabel = if (wins == 1) "win" else "wins"
        return "${formatPts(points)} (${wins} ${winLabel})"
    }

    fun pluralize(count: Int, singular: String, plural: String = "${singular}s"): String {
        return if (count == 1) singular else plural
    }
}
